import React, { Fragment } from 'react';
import classes from './LoginForm.module.css';
import FullBackground from '../../UI/FullBackground/FullBackground';
import { companyLogo } from '../../../images.js';

const loginForm = (props) => (
	<Fragment>
		<FullBackground />
		<div className={classes.Container}>
			<form className={classes.Form} onSubmit={props.submit}>
				<img src={companyLogo} alt="Company Logo" />
				<div>
					{props.children}
				</div>
			</form>
		</div>
	</Fragment>
)

export default loginForm;